import React, { memo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {
  PaymentMethodCardStyled,
  Wrapper,
  StyledIcon,
  StyledTitle,
} from './styles/PaymentMethodCardStyled';

const cards = {
  card: {
    to: '/payment',
    name: 'card',
    color: '#808080',
    size: 38,
    text: 'Кредитная карта',
  },
  mobile: {
    to: '',
    name: 'phone',
    color: '#808080',
    size: 38,
    text: 'Мобильный платёж',
  },
  promocode: {
    to: '',
    name: 'promo',
    color: '#808080',
    size: 38,
    text: 'Использовать промокод',
  },
  other: {
    to: '',
    name: 'other_payment',
    color: '#808080',
    size: 38,
    text: 'Другие способы оплаты',
  },
};

const PaymentMethodCard = ({ type, onClick }) => {
  const item = _.get(cards, type);
  return (
    <PaymentMethodCardStyled onClick={onClick}>
      <Wrapper>
        <StyledIcon name={item.name} color={item.color} size={item.size} />
        <StyledTitle font="din_medium" color="gray_nightrider">
          {item.text}
        </StyledTitle>
      </Wrapper>
    </PaymentMethodCardStyled>
  );
};

PaymentMethodCard.propTypes = {
  type: PropTypes.oneOf(['card', 'mobile', 'promocode', 'other']),
  onClick: PropTypes.func.isRequired,
};

PaymentMethodCard.defaultProps = {
  type: 'card',
};

export default memo(PaymentMethodCard);
